import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'

export default class extends Controller {
  static targets = ['hamburger', 'menu']

  connect() {
    useClickOutside(this, { element: this.element })

    document.getElementById('sidebar-layer').addEventListener('click', () => {
      this.close()
    })
  }

  toggle(e) {
    if (this.menuTarget.classList.contains('sidebar--active')) {
      this.close(e)
    } else {
      this.open()
    }
  }

  open() {
    document.getElementById('sidebar-layer').classList.remove('hidden')
    document.body.classList.add('overflow-hidden')
    this.menuTarget.classList.add('sidebar--active')
    this.hamburgerTarget.classList.add('header__menu-btn-burger-open')
    this.menuTarget.querySelector('#main-menu').classList.remove('hidden')
  }

  close() {
    this.menuTarget.classList.remove('sidebar--active')
    document.getElementById('sidebar-layer').classList.add('hidden')
    document.body.classList.remove('overflow-hidden')
    this.hamburgerTarget.classList.remove('header__menu-btn-burger-open')
    setTimeout(() => this.hideMenu(), 400)
  }

  clickOutside(event) {
    if (this.isOpen) {
      event.preventDefault()
      this.close()
    }
  }

  hideMenu() {
    this.menuTarget.querySelector('#main-menu').classList.add('hidden')
  }
}
